import { CliError, CliErrorCode } from '@wix/cli-error';
import type { CommandServices } from '@wix/cli-command-contract';
import {
  resolvePackageManager,
  resolveNpmDependencies,
} from '../velo-npm/index.js';
import { createLogger } from '../logger.js';
import { createI18nT } from '../i18n.js';
import type { ProjectModel } from '../model.js';
import { authenticate } from '../authentication.js';

export async function uninstall(
  model: ProjectModel,
  services: CommandServices,
  options: {
    yarn?: boolean;
    npm?: boolean;
  },
  initialPackageName: string
) {
  const t = createI18nT();
  const logger = createLogger({ t });

  const authState = await authenticate({
    metaSiteId: model.metaSiteId,
    biLogger: services.biLogger,
    errorReporter: services.errorReporter,
    loginMode: services.loginMode,
  });

  const packageName = initialPackageName.trim();

  if (!packageName) {
    throw new CliError({
      code: CliErrorCode.WixUninstallMissingPackageName(),
      cause: null,
    });
  }

  const logDependencyUninstalled =
    logger.logDependencyUninstalling(packageName);

  try {
    const packageManager = await resolvePackageManager(
      model.projectFolder,
      options
    );
    await packageManager.runUninstallPackage(model.projectFolder, packageName);
    await resolveNpmDependencies(model.projectFolder, { authState });
    logDependencyUninstalled.success();
  } catch (error) {
    logDependencyUninstalled.fail();
    throw error;
  }
}
